module.exports = __webpack_public_path__ + "img/verify-email-success.b2f74c2b.svg";